export default "__VITE_ASSET__C6YXU7Zm__"